import React from "react";

const CurrencyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24px"
      height="24px"
      viewBox="0 0 300 300"
    >
      <rect width="300" height="300" fill="#fff" />
      <g transform="translate(150 150)">
        <path
          d="m124.66 0c0 68.85-55.814 124.66-124.66 124.66-68.85 0-124.66-55.814-124.66-124.66 0-68.85 55.814-124.66 124.66-124.66 68.85 0 124.66 55.814 124.66 124.66z"
          fill="#fff"
          stroke="#000"
          strokeLinecap="square"
          strokeWidth="20"
        />
        <path d="m31.046-42.987q-4.361-13.291-23.674-13.498v46.517q1.6613 0.41534 5.1916 1.246 16.198 3.738 22.428 6.853t11.629 10.176q6.4377 8.5143 6.4377 20.144 0 11.006-6.0224 20.455-6.0223 9.4489-15.99 14.018-9.1373 4.361-23.674 7.0607v17.652q0 5.3993-5.8147 5.3993t-5.8147-5.3993v-17.652q-15.367-1.0384-25.958-5.5032t-16.717-12.772q-6.1262-8.3066-6.1262-18.275 0-8.5143 4.1534-13.706 4.1533-5.1917 11.006-5.1917 4.5686 0 7.6836 3.0112t3.115 7.5798q0 8.9297-10.799 9.5527 1.0383 9.7603 10.072 15.575 9.0335 5.8146 23.57 6.0223v-52.332l-3.115-0.83066q-16.821-4.5687-22.843-7.2683-7.476-3.3227-11.629-9.345-4.7763-6.853-4.7763-17.444 0-10.799 6.0223-20.144t15.575-13.498q8.099-3.5304 20.767-5.607v-16.613q0-6.2299 5.8147-6.2299t5.8147 6.2299v16.613q18.69 2.0766 29.696 10.383 11.006 8.3066 11.006 20.351 0 5.3993-3.3227 9.0335-3.3227 3.6341-8.3066 3.6341-4.1534 0-7.0607-2.6996-2.9073-2.6997-2.9073-6.4377 0-4.1533 4.5686-7.0606zm-35.303 30.527v-44.025q-11.629 0.4154-19.001 6.6454-7.3722 6.23-7.3722 15.783 0 8.3067 4.984 12.772t17.652 7.7875q1.0383 0.2077 3.738 1.0383zm11.629 18.898v49.84q12.668-0.2077 21.078-7.476t8.4105-18.275q0-10.176-6.0223-15.575-6.0224-5.3994-19.936-7.8913-0.8307-0.20767-3.5303-0.623z" />
      </g>
    </svg>
  );
};
export default CurrencyIcon;
